import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MaterialUILink from '@material-ui/core/Link';
import { fetchProductFilterCount, setProductFilters } from '../../redux/actions/resultsActions';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, isNil } from 'lodash';
import FilterLabel from './FilterLabel';

const useStyles = makeStyles((theme) => ({
	clearFilters: {
		top: '25%',
	},
}));

const ShowNonBuyableFilter = ({ isBuyable }) => {
	const dispatch = new useDispatch();
	const buyableCount = useSelector((state) => state.results.productFilterCount.buyable);
	const handleChange = (event) => {
		dispatch(setProductFilters({ isBuyable: !event.target.checked }));
	};
	return (
		<FormControlLabel
			disabled={buyableCount === 0}
			control={
				<Checkbox
					checked={!isBuyable}
					color="primary"
					onChange={handleChange}
					inputProps={{ 'aria-label': 'primary checkbox' }}
				/>
			}
			label={<FilterLabel message="Show Only non-buyable items" count={buyableCount} />}
		/>
	);
};

function ProductGridFilters({ products, setFilteredProducts, query }) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const prodFilters = useSelector((state) => state.results.productFilters);
	const { isBuyable } = prodFilters;

	const ResetFilters = () => {
		dispatch(setProductFilters({ isBuyable: true }));
	};
	useEffect(() => {
		// default: display assets with buyable linked products. only display nonBuyable products linked assets when filter is applied.
		setFilteredProducts(products);
		if (!isEmpty(query) && !isNil(query)) {
			dispatch(fetchProductFilterCount(query));
		}
	}, [products, setFilteredProducts, query, dispatch]);

	return (
		<Grid container spacing={2}>
			<Grid item>
				<ShowNonBuyableFilter isBuyable={isBuyable} />
			</Grid>
			<Grid item>
				<MaterialUILink
					component="button"
					variant="body2"
					onClick={() => {
						ResetFilters();
					}}
					className={classes.clearFilters}
				>
					Clear Filters
				</MaterialUILink>
			</Grid>
		</Grid>
	);
}

export default ProductGridFilters;
